module.exports = __webpack_public_path__ + "static/img/A164.5f010cba.jpg";